import {createSelector} from "@reduxjs/toolkit";
import {CommonState} from "..";
import {InitialState} from "./types";
import {Attestation} from "../../common/attestsation";

export const selectAttestationsReducer = (state: CommonState): InitialState => state.attestation;

export const selectAttestations = createSelector(
    [(state: CommonState) => selectAttestationsReducer(state)],
    (state: InitialState): Attestation[] => Object.values(state.attestations || {}),
);

export const selectAttestationById = createSelector(
    [
        (state: CommonState) => selectAttestationsReducer(state),
        (state: CommonState, id: string) => id, 
    ],
    (state: InitialState, id: string): Attestation => state.attestations[id],
);

export const selectAttestationStatistic = createSelector(
    [(state: CommonState) => selectAttestationsReducer(state)],
    (state: InitialState): Attestation[] => Object.values(state.statistic || []),
)